import React from 'react';

import {getDataWithPromise, Globals} from "root/globals";
import {handleAjaxError} from "root/DataFunctions/ErrorHandlingFunctions";

export const getSchool360SchoolsByLea = (lea_id, onComplete) =>
{
    const url = Globals.APIFolder + '/school360/schools/' + lea_id ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const modifyGDPRAccessForSchool = (school_id, enabled_flag, onComplete) =>
{
    const url = Globals.APIFolder + "/school/" + school_id +"/gdpraccess";

    const data = {
        access: enabled_flag
    }

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}